import serviceBase from '../../../../Services/serviceBase'

class DonateActions {
  fetchDonateData = async (fireDepartmentIdentifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/donates/donate-by-department/${fireDepartmentIdentifier}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }


  fetchDonateDataPreview = async (fireDepartmentIdentifier) => {
    let url = `${window._env_.COMMUNITY_API_URL}/donate-preview/${fireDepartmentIdentifier}`
    return serviceBase.get(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }

  postPublishDonate = async (fireDepartmentIdentifier) =>{
    let url = `${window._env_.COMMUNITY_API_URL}/donate-preview/publish/${fireDepartmentIdentifier}`
    return serviceBase.post(url).then(
      (response) => {
        return response.data
      },
      (err) => {}
    )
  }
}

export default new DonateActions()
